export default __webpack_public_path__ + "static/deviceManagement-d3522a1ba0afb3668887747cecd36e86.svg";